// src/utils/cache/clearAllUserData.js
import { clearUserCache } from './userCache';
import { resetUserState } from '../../store/user/user.action';
import { resetShowcaseState } from '../../store/showcase/showcase.action';
import { resetCardState } from '../../store/card/card.action';
import { resetSystemState } from '../../store/system/system.action';

/**
 * Clears ALL user data from localStorage and Redux
 * This should be called when switching between users to prevent data leakage
 */
export const clearAllUserData = (dispatch) => {
  
  // Clear all localStorage caches
  clearUserCache(); // Clears all user caches
  
  // Clear any other localStorage data that might be user-specific
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.startsWith('userData_') ||
      key.startsWith('user_') ||
      key.includes('showcase') ||
      key.includes('tokens') ||
      key.includes('collection') ||
      key.includes('card') // Added to clear card-related localStorage
    )) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  
  
  // Clear Redux state for all stores with single reset actions
  dispatch(resetUserState()); // Reset user state (preserves teamIndex)
  dispatch(resetShowcaseState()); // Reset showcase state
  dispatch(resetCardState()); // Reset card state
  dispatch(resetSystemState()); // Reset system state
};
